import React, { Fragment } from 'react';
import ConsolidatedDaywiseReportView from './ConsolidatedDaywiseReportView';

// Thin route entry — the V3 shell lives inside the view.
const ConsolidatedDaywiseReport = () => (
    <Fragment>
        <ConsolidatedDaywiseReportView />
    </Fragment>
);

export default ConsolidatedDaywiseReport;
